import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})

export class SignUpComponent implements OnInit {

  // TODO: Create user model instead?
  user = {
    email: "",
    password: "",
    confirmPassword: "",
    ageUnder18: null as boolean|null
  };

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    console.log("component initialized")
  }

  onPasswordChange(event: any)
  {
    this.user.confirmPassword = "";
  }

  // Update user in UserService TODO: Theres a better way of doing this
  onSubmit() {
    this.userService.user.signup = true as any;
    this.userService.user.email = this.user.email;
    this.userService.user.password = this.user.password;
    this.userService.user.ageUnder18 = !!this.user.ageUnder18;

    // Check if email exists, if it doesn't it will go to next page
    this.userService.checkEmailAvailability({ email: this.user.email });
  }
}
